<template>
  <div>
    <CptVip
      v-if="isJoin == 1"
      ref="isVip"
      :activityId="activityId"
      :signInfo="signInfo"
      :taskData="taskData"
    />
    <CptNotVip
      v-if="isJoin == 0"
      ref="notVip"
      :activityId="activityId"
      :signInfo="signInfo"
      :taskData="taskData"
    />
  </div>
</template>
<script>
import CptVip from './components/activity4/cpt-vip.vue'
import CptNotVip from './components/activity4/cpt-not-vip.vue'
export default {
  name: 'user-sign-index',
  components: {
    CptNotVip,
    CptVip
  },
  props: {
    activityId: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      options: { barBackgroundColor: 'rgba(0,0,0,0)' },
      activity_id: 2,
      signInfo: {
        user_plan_state: 0,
        is_sign: 0,
        day_num: 0
      },
      taskData: [],
      isJoin: -1
    }
  },
  created() {
    this.getParams()
    this.addEventPage()
    this.getSignInfo()
    this.getTaskInfo()
  },
  methods: {
    getParams() {
      this.activity_id = this.activityId
    },
    addEventPage() {
      window.onPageResumed = () => {
        this.getSignInfo()
        this.getTaskInfo()
      }
    },
    bindBack() {
      this.$http.appBack()
    },
    /* 获取签到信息 */
    async getSignInfo() {
      let res = await this.$http
        .getAppWithAppInfo('api/v1/SignActivity/zeroBuyActivityInfo', {
          activity_id: this.activity_id
        })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (res.data) {
            this.isJoin = res.data.is_joiner
            this.signInfo = res.data
          }
        } else if (res.code == 10001) {
          this.$toast('抱歉,您暂未获取活动资格')
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async getTaskInfo() {
      let res = await this.$http
        .getAppWithAppInfo('api/v1/Vote/getVotePlanList', {
          activity_id: this.activity_id,
          activity_source: 1
        })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.taskData = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.sign {
  .back-container {
    position: fixed;
    z-index: 2;
    width: 100%;
    top: 0;
    left: 0;
  }

  .container {
    position: relative;
    overflow: hidden;
    min-height: 100vh;
    .bg-image {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }
    .back {
      z-index: 999;
      position: absolute;
      left: 14px;
      top: 20px;
      width: 30px;
      height: 30px;
      background: rgba(0, 0, 0, 0.16);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      .iconfont {
        color: #fff;
        font-size: 18px;
      }
    }

    .back-wrapper {
      position: relative;
    }

    .btn-list {
      z-index: 999;
      position: absolute;
      right: 14px;
      top: 20px;
      display: flex;
      flex-direction: column;

      .btn-item {
        margin-bottom: 12px;
        width: 30px;
        height: 30px;
        background: rgba(0, 0, 0, 0.16);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #ffffff;
        line-height: 20px;

        .iconfont {
          font-size: 14px;
          font-weight: 700;
        }
      }
    }

    .activity-time {
      position: absolute;
      left: 0;
      top: 86px;

      .time-image {
        width: 134px;
        height: 61px;
      }

      .time-duration {
        font-family: PingFangSC, PingFang SC;
        padding: 0px 6px;
        font-weight: bold;
        font-size: 14px;
        height: 28px;
        line-height: 28px;
        position: absolute;
        transform: rotate(-5deg);
        top: 33px;
        left: 0;
      }
    }

    .wrapper {
      margin-top: 570px;
      .top {
        position: relative;
        margin-bottom: 27px;

        .notice-component {
          position: absolute;
          position: absolute;
          left: 0px;
          top: -46px;
          width: 100%;
          padding: 0px 14px;
          box-sizing: border-box;
          height: 40px;
          z-index: 999;
          overflow: hidden;
        }

        .prize-user-container {
          width: 100%;
          height: 40px;
          position: absolute;
          left: 0px;
          top: -46px;

          .prize-user-overflow {
            height: 100%;
            overflow: hidden;
          }

          .prize-user-content {
            height: 26px;

            ::v-deep .van-notice-bar {
              height: 100%;
            }

            ::v-deep .van-notice-bar__wrap {
              overflow: visible;
            }

            ::v-deep .van-ellipsis {
              overflow: visible;
            }

            ::v-deep .van-swipe {
              overflow: visible;
            }
          }
        }

        .prize-user-swipe {
          height: 26px;

          .prize-user-item {
            display: inline-block;
            padding: 0px 7px;
            white-space: nowrap;
            height: 20px;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 10px;
            backdrop-filter: blur(6px);
            font-size: 10px;
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            color: #ffffff;
            line-height: 20px;
          }
        }

        .integral-content {
          height: 50px;
          display: flex;
          align-items: center;
          background: rgba(255, 255, 255, 0.93);
          box-shadow: 0px 5px 9px 0px rgba(75, 195, 156, 0.47);
          border-radius: 26px;
          border: 2px solid #ffffff;
          backdrop-filter: blur(9px);
          margin-bottom: 17px;
          position: relative;

          .mask {
            border-radius: 25px;
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            overflow: hidden;
          }

          .integral-dot-filter {
            position: absolute;
            width: 125px;
            height: 125px;
            background-color: #fff9cd;
            border-radius: 50%;
            filter: blur(36px);
            left: -46px;
            top: -90px;
          }

          .integral-item {
            position: relative;
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .integral-flag {
              position: absolute;
              left: 50%;
              top: 0;
              transform: translate(-50%, -90%);
              width: 104px;
              height: 22px;
              object-fit: contain;
            }

            .integral-icon {
              width: 20px;
              height: 20px;
              margin-right: 6px;
            }

            .integral-text {
              font-size: 18px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.8);
              line-height: 25px;
            }

            .integral-num {
              position: relative;
              font-size: 26px;
              font-family: DIN, DIN;
              font-weight: bold;
              color: #ff6464;
              line-height: 31px;
              margin-right: 4px;
            }

            .iconfont {
              font-size: 18px;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.3);
            }
          }

          .integral-item-first::after {
            content: '';
            position: absolute;
            top: 50%;
            right: 0%;
            transform: translate(-50%, -50%);
            width: 1px;
            height: 16px;
            background-color: rgba(0, 0, 0, 0.12);
          }
        }
      }

      .logo {
        margin: 0 auto 80px;
        height: 16px;
      }
    }
  }
}

.toast-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
